import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PublicFacilityAnimal {
  id: string;
  name: string;
  species_common: string | null;
  species_scientific: string;
  sex: string | null;
  status: string;
  public_health_status: string;
  public_health_last_updated: string | null;
  public_feeding_summary: string;
  public_diet_label: string;
  public_weight_summary: string;
  has_photo: boolean;
  photo_url: string | null;
}

/**
 * Hook to fetch public facility animals for a given username
 * Used on the public profile page to display facility animals list
 */
export const useFacilityAnimals = (username: string | undefined, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['facility-animals', username],
    queryFn: async () => {
      if (!username) return [];
      
      const { data, error } = await supabase
        .rpc('get_public_facility_animals', { p_username: username });
      
      if (error) {
        console.error('Error fetching facility animals:', error);
        throw error;
      }
      
      return (data || []) as PublicFacilityAnimal[];
    },
    enabled: enabled && !!username,
  });
};
